import React from 'react';
import { Mail } from 'lucide-react';
import { useScrollTracking } from '../hooks/useScrollTracking';
import { trackExternalLink } from '../utils/mixpanel';
export function Footer() {
  const sectionRef = useScrollTracking('footer');
  const handleBackToThrulineClick = () => {
    trackExternalLink('Back to Thruline', 'https://www.thruline.ai', 'footer');
  };
  return <footer ref={sectionRef as any} className="bg-slate-900 text-slate-300 py-16 px-6" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        <div className="flex flex-col items-center text-center space-y-8" data-id="element-70">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-71">
            <img src="https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/icon-light-trans.png" alt="Thruline" className="h-6" data-id="element-72" />
            <div data-id="element-73">
              <div className="text-white font-bold text-lg" data-id="element-74">CAD Sync</div>
              <div className="text-xs text-slate-400" data-id="element-75">Powered by Thruline</div>
            </div>
          </div>

          {/* Back to Thruline link */}
          <div data-id="element-76">
            <a href="https://www.thruline.ai" target="_blank" rel="noopener noreferrer" onClick={handleBackToThrulineClick} className="text-sm text-slate-400 hover:text-white transition-colors" data-id="element-77">
              ← Back to Thruline
            </a>
          </div>

          {/* Copyright */}
          <div className="text-sm text-slate-500" data-id="element-78">
            © 2026 CAD Sync by Thruline. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}